module.exports = __webpack_public_path__ + "static/media/banner_pronostico.0194690b.png";